import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../@core/services/auth.service';
import { RbacService } from '../@core/services/rbac.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private auth = inject(AuthService);
  private rbac = inject(RbacService);
  private router = inject(Router);

  async canActivate(): Promise<boolean> {
    // Wait for auth to be ready first
    await this.auth.waitForAuthReady();

    // Check if user is authenticated
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['/login']);
      return false;
    }

    // Check if user needs to change password (migrated accounts)
    const user = this.auth.user();
    if (user?.user_metadata?.['force_password_change']) {
      this.router.navigate(['/auth/force-change-password']);
      return false;
    }

    // Load permissions for authenticated user (runs before child guards)
    await this.rbac.loadUserPermissions();

    return true;
  }
}
